var withAdClickedEvent = function withAdClickedEvent() {
  return function () {
    return {
      schema: 'iglu:au.com.realestate/media_ads_clicked/jsonschema/1-0-0',
      data: {
        event_name: 'media_ads_clicked'
      }
    };
  };
};

export default withAdClickedEvent;
//# sourceMappingURL=withAdClickedEvent.js.map